import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useCallback, useState, type FC } from "react";
import { useFlags } from "../../../../../server/optimizely";
import { FollowUpSidebarReason } from "../../../../follow-up/component/follow-up-sidebar-reason";
import { type FollowUp } from "../../../../follow-up/server/follow-up-service";
import type { FollowUpMomentDetails } from "../../../../follow-up/server/types";
import { classifyMomentWhen } from "../../../../moment-card/components/moment-card-when";

export const CreateFollowUpDialog: FC<{
  open: boolean;
  onClose(): void;
  data: FollowUpMomentDetails;
}> = ({ open, onClose, data }) => {
  const {
    flags: { follow_up_link_click },
  } = useFlags("follow_up_link_click");

  const [value, setValue] = useState<FollowUp["config"]>({
    type: "no_interaction",
    source_id: data.id,
  });

  const launchFollowUpPage = useCallback(() => {
    if (!value) return;

    if (value.type === "no_survey_completion") {
      window.open(`/follow-up/moment/${data.id}/survey/${value.survey_id}`, "_blank");
    } else {
      window.open(`/follow-up/moment/${data.id}`, "_blank");
    }

    onClose();
  }, [value, data.id, onClose]);

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Select a Follow-Up reason</DialogTitle>
      <DialogContent>
        <FollowUpSidebarReason
          whenClassification={classifyMomentWhen(data)}
          value={value}
          onChange={setValue}
          source_id={data.id}
          surveys={data.surveys}
          hyperlinks={data.hyperlinks ?? []}
          showLinkClick={follow_up_link_click}
          error={{ error: false }}
          disabled={false}
        />
      </DialogContent>
      <DialogActions>
        <Button
          data-analytics-id="moment-form-create-follow-up-cancel-button"
          variant="text"
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          data-analytics-id="moment-form-create-follow-up-confirm-button"
          variant="contained"
          onClick={launchFollowUpPage}
        >
          Create Follow-Up
        </Button>
      </DialogActions>
    </Dialog>
  );
};
